import React from "react";
import { connect } from "dva";

// core components
import LayoutRC from "../../components/layout";

// sections for this page
// import FeatureComponent from "./sections/feature";
import CsComponents from "./sections/carousel";
import NotiBar from "./sections/notificationbar";

// about
import BannerComponent from "../about/sections/bannercomponent";
import MainContent from "../about/sections/maincontent";
// import TestimonialComponent from "../about/sections/testimonialcomponent";

// Other
import ZendeskJs from "../../components/zendesk/zendeskjs";
import AOSComp from "../../components/aos/aoscomp";
import AnimateCss from "../../components/AnimateCss/animate";



const notiDefault = [
  {
    Title: "FIL、XCH出金を再開しました",
    Link: "https://support.btcfx.io/hc/ja/articles/4412898664473",
  },
  {
    Title: "MiPool アカウントの出金機能について",
    Link: "https://btcfx.zendesk.com/hc/ja/articles/4408557510809",
  },
  {
    Title: "【重要】BtcFXよりMiPoolへ資産移転のお客様へ",
    Link: "https://support.btcfx.io/hc/ja/articles/4407973912857",
  },
  {
    Title: "MiPoolにて配当資産の計上が完了しました",
    Link: "https://support.btcfx.io/hc/ja/articles/4409949975065",
  },
];

const Index = ({ layout, dispatch}) => {

const noti =
  layout.indexAnnounceList && layout.indexAnnounceList.length > 0
    ? layout.indexAnnounceList
    : notiDefault; 
 
  return (
    <LayoutRC>
      <CsComponents />
      <NotiBar news={noti} />
      {/* <FeatureComponent /> */}
      <BannerComponent />
      <MainContent />
      {/* <TestimonialComponent /> */}
      <ZendeskJs />
      <AOSComp />
      <AnimateCss />
    </LayoutRC>
  );
};

export default connect(({ layout }) => ({ layout }))(Index);
